export default __webpack_public_path__ + "static/media/munnypenni.fb8bce90.png";